import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { format } from 'libphonenumber-js';

@Directive({
    selector: '[EscapeCountryCode]'
})
export class EscapeCountryCode {

    @Input() countryCode: any;
    @Input() phoneNumber: any;

    constructor(private el: ElementRef) {
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (event.keyCode === 8 || event.keyCode === 46) {
            let newCode = format(' ', this.countryCode, 'International');
            if (newCode === this.phoneNumber) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }

    }
    ngOnInit() {
    }
}